var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVendorLikeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    fill: "#F5FBEA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.16504,
    y: 0.98999,
    width: 37,
    height: 37,
    rx: 18.5,
    stroke: "#E8E8E8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2979 13.6294C27.0205 15.106 27.1025 17.731 25.5713 19.3169L20.2666 24.7856C19.9385 25.1411 19.3643 25.1411 19.0361 24.7856L13.7314 19.3169C12.2002 17.731 12.2822 15.106 14.0049 13.6294C15.5088 12.3442 17.751 12.5903 19.1182 14.0122L19.665 14.5591L20.1846 14.0122C21.5791 12.5903 23.7939 12.3442 25.2979 13.6294Z",
    fill: "#3A6D33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVendorLikeIcon);
export default __webpack_public_path__ + "static/media/vendor-like-icon.7581301f94b09b0d194f94b32a3c1a37.svg";
export { ForwardRef as ReactComponent };